// extracted by mini-css-extract-plugin
export default {"columnLeft":"BlockchainSearchForm_columnLeft__vUK5B","columnRight":"BlockchainSearchForm_columnRight__bC4of","spin":"BlockchainSearchForm_spin__IKO3E"};